import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { ProductReview } from "../../models/Products";
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Product review form
 */

export class ProductReviewForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.fields = [{
      label: 'Тип',
      name: 'type',
      type: BaseForm.TYPES.DROPDOWN,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(ProductReview.typesTitle)
        }
      }
    }, {
      label: 'Заголовок',
      name: 'title'
    }, {
      label: 'Ваше имя',
      name: 'name',
      required: true
    }, {
      label: 'Отзыв',
      name: 'text',
      required: true,
      props: {
        native: {
          multiline: true,
          textAlignVertical: 'top'
        }
      }
    }, {
      label: 'Достоинства',
      name: 'advantages',
      props: {
        native: {
          multiline: true,
          textAlignVertical: 'top'
        }
      }
    }, {
      label: 'Недостатки',
      name: 'disadvantages',
      props: {
        native: {
          multiline: true,
          textAlignVertical: 'top'
        }
      }
    }, {
      label: 'Голос',
      name: 'vote',
      type: BaseForm.TYPES.CUSTOM,
      required: true
    }];
    this.dispatchCreateForm = DispatchSelector.productsReviews.create;
    this.responseCreateState = StateSelector.productsReviews.create;
    this.dispatchUpdateForm = DispatchSelector.productsReviews.update;
    this.responseUpdateState = StateSelector.productsReviews.update;
  }

}